module.exports = __webpack_public_path__ + "static/media/greyext.70f54d68.svg";